module.exports = __webpack_public_path__ + "static/media/nedj.55ba71b8.webp";